import React, { useState } from 'react';
import { Button, Confirm, useDataProvider, useNotify, useRecordContext, useRefresh } from 'react-admin';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

interface ScoringDisableButtonProps {
  style?: React.CSSProperties;
  isOutlined?: boolean;
}

const ScoringDisableButton: React.FC<ScoringDisableButtonProps> = ({ style, isOutlined }) => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);

  if (!record) { return null; }

  const handleClick = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleConfirm = () => {
    dataProvider.update('scorings', {
      id: record.id,
      data: { isEnabled: !record.isEnabled },
      previousData: record
    })
      .then(() => {
        notify(record.isEnabled ? 'Pontuação desativada com sucesso' : 'Pontuação ativada com sucesso');
        refresh();
      })
      .catch((error) => {
        notify(error.message || 'Erro ao atualizar pontuação', { type: 'warning' });
      })
      .finally(() => {
        setOpen(false);
      });
  };

  return (
    <>
      <Button
        onClick={handleClick}
        label={record.isEnabled ? 'Desativar' : 'Ativar'}
        variant={isOutlined ? 'outlined' : 'text'}
        style={style}
      >
        {record.isEnabled ? <BlockIcon /> : <CheckCircleOutlineIcon />}
      </Button>
      <Confirm
        isOpen={open}
        title={record.isEnabled ? 'Desativar pontuação' : 'Ativar pontuação'}
        content={record.isEnabled
          ? 'Tem certeza que deseja desativar esta pontuação?'
          : 'Tem certeza que deseja ativar esta pontuação?'}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};

export default ScoringDisableButton;
